import { currentWallet } from '@cronos-app/wallet';

import { useProfileDrawer } from './useProfileDrawer';

export const useIsMyAccount = (): boolean => {
  const myAccount = currentWallet.useAccount();
  const drawerAccount = useProfileDrawer((s) => s.account);
  return (
    !!myAccount &&
    !!drawerAccount &&
    myAccount.toLowerCase() === drawerAccount.toLowerCase()
  );
};
